// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse {
  0% {
    stroke-width: calc(5px / var(--vis-map-current-zoom-level, 1));
    stroke-opacity: 1;
  }
  100% {
    stroke-width: calc(20px / var(--vis-map-current-zoom-level, 1));
    stroke-opacity: 0;
  }
}

.mmap [class*="point-shape"] {
  animation: pulse 1.5s ease-in-out infinite;
}`, "",{"version":3,"sources":["webpack://./src/examples/maps/topojson/malicious-user/style.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,8DAA8D;IAC9D,iBAAiB;EACnB;EACA;IACE,+DAA+D;IAC/D,iBAAiB;EACnB;AACF;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["@keyframes pulse {\n  0% {\n    stroke-width: calc(5px / var(--vis-map-current-zoom-level, 1));\n    stroke-opacity: 1;\n  }\n  100% {\n    stroke-width: calc(20px / var(--vis-map-current-zoom-level, 1));\n    stroke-opacity: 0;\n  }\n}\n\n.mmap [class*=\"point-shape\"] {\n  animation: pulse 1.5s ease-in-out infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mmap": `mmap`,
	"pulse": `pulse`
};
export default ___CSS_LOADER_EXPORT___;
